import { createFileRoute } from '@tanstack/react-router'
import EditionTechnicalProduction from 'Edition/components/sections/Layout/EditionTechnicalProduction'

export const Route = createFileRoute(
    '/work/$workId_/edition/$editionId/layout-technicalproduction',
)({
    component: EditionTechnicalProduction,
})
